'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extend = require('@souche-f2e/extend');

var _extend2 = _interopRequireDefault(_extend);

var _utils = require('../utils');

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Promise = require('es6-promise').Promise;

var map = null;
// 获取城市数据
var getCity = function getCity() {
    return new Promise(function (resolve) {
        var citySearch = new window.AMap.CitySearch();
        map.plugin(citySearch);
        citySearch.getLocalCity(function (status, result) {
            if (status === 'complete' && result.city) {
                resolve({
                    city: result.city
                });
            } else {
                resolve({
                    city: '全国',
                    cityStatus: 'error',
                    cityMsg: result
                });
            }
        });
    });
};

// 获取经纬度
var getLonLat = function getLonLat() {
    return new Promise(function (resolve, reject) {
        // 获取位置
        var geolocation = new window.AMap.Geolocation({
            enableHighAccuracy: true, //是否使用高精度定位，默认:true
            timeout: 10000, //超过10秒后停止定位，默认：无穷大
            maximumAge: 5000, //定位结果缓存0毫秒，默认：0
            convert: true //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
        });
        // 获取城市数据
        var getCityInfo = function getCityInfo(data) {
            geolocation.getCityInfo(function (status, result) {
                if (status === 'complete' && result.info === 'SUCCESS') {
                    data.province = result.province;
                    resolve(data);
                }
            });
        };
        map.plugin(geolocation);
        map.addControl(geolocation);
        geolocation.getCurrentPosition(function (status, result) {
            if (status === 'complete' && result.info === 'SUCCESS') {
                var locationData = {
                    longitude: result.position.lng,
                    latitude: result.position.lat
                };
                if (_utils2.default.configData.province) {
                    getCityInfo(locationData);
                } else {
                    resolve(locationData);
                }
            } else {
                reject({
                    msg: result.message,
                    success: false
                });
            }
        });
    });
};

var _getPosition = function _getPosition() {
    return Promise.all([getCity(), getLonLat()]).then(function (arr) {
        return (0, _extend2.default)(arr[0], arr[1]);
    }).catch(function (err) {
        return Promise.reject(err);
    });
};

exports.default = {
    getPosition: function getPosition() {
        if (!_utils2.default.configData.http && location.protocol === 'http:') {
            throw {
                success: false,
                msg: '请使用https协议域名',
                code: 600
            };
        }
        if (!_utils2.default.hasLoad('AMap')) {
            var gaodeUrl = 'https://webapi.amap.com/maps?v=1.3&key=' + _utils2.default.configData.gaode + '&plugin=AMap.Geolocation,AMap.CitySearch';
            return _utils2.default.loadJs(gaodeUrl).then(function () {
                if (!window.AMap.Map) {
                    throw {
                        success: false,
                        msg: '高德地图加载异常',
                        code: 500
                    };
                }
                map = new window.AMap.Map('mapContainer');
                return _getPosition();
            });
        }
        map = map || new window.AMap.Map('mapContainer');
        return _getPosition();
    }
};


//////////////////
// WEBPACK FOOTER
// ./~/@souche-vue/vue-position/dist/gaode/index.js
// module id = 289
// module chunks = 4